import React from 'react';

const AlertIcon = (props) => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
);

const SafeIcon = ({ icon, ...props }) => {
  if (!icon) return <AlertIcon {...props} />;
  
  /* Handle function components (common in react-icons) */
  if (typeof icon === 'function') {
    return React.createElement(icon, props);
  }
  
  /* Handle already rendered elements or objects */
  if (typeof icon === 'object') {
    return icon;
  }
  
  return <AlertIcon {...props} />;
};

export default SafeIcon;